import * as types from '../types'
import { dayMill, statusChange } from '@/utils';
const init = {
    config: {
        headTitle: '',
        mainTitle: '',
        subTitle: '',
        icon: '',
        share: {},
        task: [],
        fare: [
        ]
    },
    info: {
        realStatus: null,
        rate: 0
    },    
}
const home = (state = init, action) => {
    if (action.type === types.HOME_HANDLE) {
        const newState = {...state}
        
        const { data: {baseRes, detailRes, timer}} = action;
        const time = timer || new Date().getTime();
        //  detailRes.accrue = 50
        // detailRes.reachNumber = 100;
        //detailRes.status = 0;
        //  detailRes.taskBeginTime = 1618760199000;
        //  detailRes.taskEndTime = 1618932999000;
        // detailRes.frozenTime = 1;
        // detailRes.rewardDeadline = 90;
        newState.info = {
            ...detailRes,
            page: 'home',
            reachUnitText: detailRes.reachUnit === 'ORDER'?'单': '元'
        }
        let { 
            mask, 
            rewardStartTime,
            rewardEndTime,
            showTime, 
            homeTitleText,
            homeBtnText,
            homeBtnCls,
            homeBack,
            homeBackText,
        } = statusChange(newState.info, time);
        const rate = +(detailRes.accrue / detailRes.reachNumber).toFixed(2);
        newState.info.rate = rate > 1? Number(1).toFixed(2): rate;
        newState.info = {
            ...newState.info,
            realStatus: mask,
            rewardStartTime,
            rewardEndTime,
            titleTimeText: `${homeTitleText} ${showTime}`,
            homeBtnText,
            homeBtnCls,
            homeBack,
            homeBackText,            
        }
        
        //console.log(d.rewardStartTime)
        //活动页  标题 乐高兜底文案
        if(baseRes) {
            baseRes.map(it => {
                if(it.templateInstanceKey === newState.info.parentTaskCode){
                    newState.config = it.templateData.elementList[0];
                }
            })
        }
        newState.config = {
            ...newState.config,
            mainTitle: newState.info.taskName || newState.config.taskName,
            subTitle: newState.info.taskSubTitle || newState.config.subTitle,
            icon: newState.config.icon,
        }
        return {
            ...newState,
        }
    } else if (action.type === types.HOME_HANDLE_TASK) {
        const newState = {...state}
        newState.info = action.data;
        return {
            ...state,
        }
    } 
    else if(action.type === types.HOME_HANDLE_REWARD) {

    }
    else {
        return state;
    }
}


export default home;
